import MembersOnlyTag from '@/components/fans/members-only-tag'
import UserMemberIcons from '@/components/fans/user-member-icons'
import RecommendedMaterial from '@/components/fans/recommended-material'
import TupianKeywords from '@/components/tupian/tupian-keywords'
import ShareByDemandPoolDetail from "@/components/_components/fans/member-demand-pool/ShareByDemandPoolDetail"
import PicList from '@/components/pic/pic-list/pic-list';

let _mixin = {
  components: {
    MembersOnlyTag,
    UserMemberIcons,
    RecommendedMaterial,
    TupianKeywords,
    ShareByDemandPoolDetail,
    PicList

  },
  data() {
    return {}
  }
}

export default _mixin;
